import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import OctoIcon from "../../../assets/icons/octo_icon.svg";
import PaypalIcon from "../../../assets/icons/pay-pal.svg";
import { getAdminBusinessId } from "../../../utils/authHelper";
import Loader from "../../../components/Loader/Loader";
import ConfirmModal from "../../../components/Modals/Confirm";
import { sendGetRequest, sendPostRequest } from "../../../actions/app-actions";
import { PAYPAL_APP_ID } from "../../../data/integration-app";
import { connect } from "react-redux";
import {
  Container
} from "reactstrap";

const PaypalIntegration = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  
  useEffect(() => {
    const { sendGetRequest } = props;
    setIsLoading(true);
    sendGetRequest({
      url: `admin/connected-venues/${getAdminBusinessId()}`,
      onSuccess: function (response) {
        const found = response.data.some(
          (integration) => integration.app_id === PAYPAL_APP_ID
        );
        setIsConnected(found);
        setIsLoading(false);
      },
      onError: function (error) {
        setIsLoading(false);
      },
    });
  }, []);

  /**
   *
   */
  const disconnect = (data) => {
    const { sendPostRequest } = props;
    setIsLoading(true);
    sendPostRequest({
      url: '/paypal/disconnect',
      data: {
        business_id: getAdminBusinessId(),
        app_id: PAYPAL_APP_ID,
      },
      onSuccess: function (response) {
        console.log("response", response.integrations);
        setIsConnected(false);
        setIsLoading(false);
      },
      onError: function (error) {
        setIsLoading(false);
      },
    });
  };

  /**
   * Connect paypal
   */
  const connect = () => {
    const { sendPostRequest } = props;
    setIsLoading(true);
    sendPostRequest({
      url: `/paypal/connect`,
      data: {
        business_id: getAdminBusinessId(),
      },
      onSuccess: function (response) {
        if (response.success) {
          window.location.href = response.oauth_url;
        }
        setIsLoading(false);
      },
      onError: function (error) {
        setIsLoading(false);
      },
    });
  }

  return (
    <>
      {showConfirmModal && (
        <ConfirmModal
          data={{}}
          title="Confirm"
          message="Are you sure, you want to Disconnect from Paypal ?"
          onConfirm={disconnect}
          onToggle={() => setShowConfirmModal(false)}
        />
      )}
      <Loader isShowLoader={isLoading} />
        {!isConnected ? (
        <Container fluid>
            <Link to="/integrations" className="back-btn">
            <span className="me-2 mb-2">
                <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.4806 15.9941C13.8398 15.6529 13.8398 15.0998 13.4806 14.7586L8.47062 10L13.4806 5.24142C13.8398 4.90024 13.8398 4.34707 13.4806 4.00589C13.1214 3.66471 12.539 3.66471 12.1798 4.00589L6.51941 9.38223C6.1602 9.72342 6.1602 10.2766 6.51941 10.6178L12.1798 15.9941C12.539 16.3353 13.1214 16.3353 13.4806 15.9941Z"
                    fill="currentColor"
                ></path>
                </svg>
            </span>
            All Integrations
            </Link>

            <div className="title">
            <h2>Paypal Setup</h2>
            </div>
            <div className="zoom-feature-int">
            <div className="row">
                <div className="col-md-5">
                <div className="txt ml-4">
                    <h3>Features that enhance your business:</h3>
                    <div className="stripe-info my-3">
                    <ul>
                        <li>
                        Accept secure payments for your services and events.
                        </li>
                        <li>
                        Automatically process payments when customers book appointments.
                        </li>
                        <li>
                        Manage subscriptions and recurring payments seamlessly.
                        </li>
                        <li>
                        Get paid instantly with real-time payment processing.
                        </li>
                    </ul>
                    </div>
                    <h3>Requirements</h3>
                    <div className="stripe-info my-3">
                    <ul>
                        <li>A Paypal account</li>
                        <li>
                        Complete your Paypal account verification
                        <span> to start accepting payments</span>
                        </li>
                        <li>
                        Provide business information for payment processing
                        </li>
                    </ul>
                    </div>
                    <button className="button btn btn-app w-auto" onClick={connect}>
                    Connect Paypal
                    </button>
                </div>
                </div>
                <div className="col-md-7 mt-md-0 mt-4">
                <div className="meet-info">
                    <div className="img border-end pe-3">
                    <img src={OctoIcon} alt="Octo Icon" />
                    </div>
                    <div className="img zoom-icon ms-4">
                    <img src={PaypalIcon} alt="Paypal" />
                    </div>
                </div>
                </div>
            </div>
            </div>
        </Container>
        ) : (
        <div className="integration-connected-box shadow-sm rounded-4 p-5 bg-white position-relative" style={{ maxWidth: 600, margin: "0 auto" }}>
            <div className="d-flex flex-column align-items-center justify-content-center mb-4 pb-3 border-bottom text-center">
            <div className="d-flex align-items-center justify-content-center mb-2" style={{ gap: 32 }}>
                {/* Our Logo */}
                <div className="img octo-icon d-flex align-items-center justify-content-center rounded-circle shadow-sm" style={{ background: "#f5f7fa", width: 64, height: 64 }}>
                <img src={OctoIcon} alt="Meetocto" style={{ width: 40, height: 40 }} />
                </div>
                {/* Improved chain with scissors icon */}
                <div className="d-flex align-items-center justify-content-center" style={{ width: 56, height: 56 }}>
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                    {/* Left chain link */}
                    <rect x="7" y="20" width="12" height="8" rx="4" fill="#B0B7C3" />
                    {/* Right chain link */}
                    <rect x="29" y="20" width="12" height="8" rx="4" fill="#B0B7C3" />
                    {/* Scissors cutting the chain */}
                    <g>
                    <circle cx="24" cy="24" r="3" fill="#F7B801" />
                    <rect x="22.5" y="12" width="3" height="14" rx="1.5" fill="#F7B801" transform="rotate(25 22.5 12)" />
                    <rect x="22.5" y="22" width="3" height="14" rx="1.5" fill="#F7B801" transform="rotate(-25 22.5 22)" />
                    </g>
                </svg>
                </div>
                {/* MS Teams Icon */}
                <div className="img stripe-icon d-flex align-items-center justify-content-center rounded-circle shadow-sm" style={{ background: "#f5f7fa", width: 64, height: 64 }}>
                    <img src={PaypalIcon} alt="Meetocto" style={{ width: 40, height: 40 }} />
                </div>
            </div>
            <div className="mt-3">
                <h4 className="mb-1 fw-bold text-primary" style={{ letterSpacing: ".5px" }}>
                Paypal Connected
                </h4>
                <div className="text-muted small mt-1">
                Your Paypal account is securely connected to <span className="fw-semibold">Meetocto</span>.<br />
                You can disconnect Paypal at any time using the button below.
                </div>
            </div>
            </div>

            <div className="mb-4">
            <ul className="ps-3 mb-3" style={{ listStyleType: "circle" }}>
                <li className="mb-2">Your Paypal account is securely connected to <span className="fw-semibold">Meetocto</span>. Accept payments seamlessly for your services.</li>
                <li className="mb-2">Automatic payment processing for bookings and events</li>
                <li className="mb-2">Secure payment handling with industry-standard encryption</li>
                <li className="mb-2">Real-time payment notifications and transaction tracking</li>
                <li className="mb-2">Support for multiple payment methods and currencies</li>
            </ul>
            <div className="alert alert-warning py-2 px-3 small mb-0" style={{ fontSize: ".97rem" }}>
                <i className="bi bi-exclamation-triangle me-2"></i>
                Disconnecting will stop payment processing. Existing transactions and customer data remain in your Paypal dashboard.
            </div>
            </div>
            <div className="d-flex justify-content-center button">
            <button
                className="btn btn-app"
                style={{ fontWeight: 500, fontSize: "1.05rem", borderRadius: "0.5rem" }}
                onClick={() => setShowConfirmModal(true)}
            >
                Disconnect Paypal
            </button>
            </div>
        </div>
        )}
    </>
  );
};

export default connect(null, { sendGetRequest, sendPostRequest })(
  PaypalIntegration
);

